module.exports = __webpack_public_path__ + "img/Grillwürstchen.23ad342f.svg";